import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectCustomerNotificationsSettings } from '@/features/domain/territory'
import { NotificationFormValues } from '@/notificationForms'

export type AlmostThereNotificationValues = ReturnType<typeof useAlmostThereNotificationValues>

/**
 * That hook grabs almostThereNotification values from the domains, than filter some of them out and
 * does some type conversion where required
 */
export function useAlmostThereNotificationValues(): NotificationFormValues {
  const notificationSettings = useSelector(selectCustomerNotificationsSettings)

  return useMemo(() => {
    const { proximityThresholdMins, includeMessageUnsubscriptionInstructions, ...rest } =
      notificationSettings['almostThereSettings']

    return {
      ...rest,
      proximityThresholdMins: proximityThresholdMins.toString(),
      windowOfCommitmentToleranceMins: '30',
      notificationCutoffMins: 0,
      windowOfCommitmentSnapToMins: 0,
      alwaysNotifyAfterCutoff: false,
      toleranceMins: 'No',
      // includeMessageUnsubscriptionInstructions should alwayes be true for phone
      includeMessageUnsubscriptionInstructionsPhone: true,
      // includeMessageUnsubscriptionInstructions should be based on the value from the domain for email
      includeMessageUnsubscriptionInstructionsEmail: includeMessageUnsubscriptionInstructions,
    }
  }, [notificationSettings])
}
